import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import artistsReducer from "./slices/artistsSlice";
import customPackageReducer from "./slices/customPackage";
import userReducer from "./slices/userSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    artists: artistsReducer,
    customPackage: customPackageReducer,
    user: userReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
